export default {
    SurflyCoBrowsingWidget: function () {
        return import(
        /* webpackPrefetch: true, webpackChunkName: "SurflyCoBrowsingWidget" */
        './components/SurflyCoBrowsingWidget');
    },
    TimerWidget: function () {
        return import(
        /* webpackPrefetch: true, webpackChunkName: "TimerWidget" */
        './components/TimerWidget');
    },
};
